// 惰性スクロール
import Lenis from 'lenis';

document.addEventListener('DOMContentLoaded', function(event) {
  const lenis = new Lenis({
    autoRaf: true,
    prevent: (node) => node.classList.contains('js-smooth-scroll-prevent'),
    anchors: {
      offset: Math.floor(document.querySelector('.l-header').clientHeight) * -1,
      // onComplete: ()=>{  // callback
      //   console.log('scrolled to anchor')
      // }
    }
  });
  window.setSmoothScroll = true;
});